import React from "react";
import "./SuccessPopup.css";

function SuccessPopup(props) {
  return props.trigger ? (
    <div className="popup" onClick={() => props.setTrigger(false)}>
      <div className="popup-inner-success">{props.children}</div>
    </div>
  ) : (
    ""
  );
}

export default SuccessPopup;
